import {
  CREATE_USER_DEFINED_PROMPT,
  DEFAULT_WIP_CLIENT_SUMMARY_SYSTEM_PROMPT,
  DELETE_USER_DEFINED_PROMPT,
  MY_USER_DEFINED_PROMPTS,
  UPDATE_USER_DEFINED_PROMPT,
} from './query'

export const myUserDefinedPrompts = async (client, purpose) => {
  const { data } = await client.query({
    query: MY_USER_DEFINED_PROMPTS,
    variables: { purpose },
    fetchPolicy: 'network-only',
  })
  return data.myUserDefinedPrompts
}

export const createUserDefinedPrompt = async (client, input) => {
  const { data } = await client.mutate({
    mutation: CREATE_USER_DEFINED_PROMPT,
    variables: { data: input },
  })
  return data.createUserDefinedPrompt
}

export const updateUserDefinedPrompt = async (client, input) => {
  const { data } = await client.mutate({
    mutation: UPDATE_USER_DEFINED_PROMPT,
    variables: { data: input },
  })
  return data.updateUserDefinedPrompt
}

export const deleteUserDefinedPrompt = async (client, id) => {
  const { data } = await client.mutate({
    mutation: DELETE_USER_DEFINED_PROMPT,
    variables: { id },
  })
  return data.deleteUserDefinedPrompt
}

export const getDefaultWipClientSummarySystemPrompt = async client => {
  const { data } = await client.query({
    query: DEFAULT_WIP_CLIENT_SUMMARY_SYSTEM_PROMPT,
    fetchPolicy: 'network-only',
  })
  return data.defaultWipClientSummarySystemPrompt
}
